import { Stack } from '@mui/material';
import AccessDenied from 'components/AccessDenied';
import Loader from 'components/Loader';
import PrivateLayout from 'layout/PrivateLayout';
import PublicLayout from 'layout/PublicLayout';
import { IRoute } from 'models/route';
import {
	initAdminUserData,
	Selectors,
} from 'modules/Authentication/store/slice';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate, useRoutes } from 'react-router-dom';
import ProtectedRoute from './ProtectedRoute';
import GLOBAL_ROUTES from './routes';

const renderRoutes = (routes: IRoute[]) => {
	const _routes: any[] = [];
	routes.forEach((route: IRoute, index: number) => {
		const renderRoute = route?.private ? (
			<ProtectedRoute key={index} route={route} roles={route?.roles} />
		) : (
			React.createElement(route.element, { name: route?.name })
		);

		return _routes.push({
			path: route?.path,
			element: renderRoute,
			children: (route?.children && renderRoutes(route?.children)) || [],
		});
	});
	return _routes;
};

const AppRoutes = (): any => {
	const dispatch = useDispatch();
	const isLoading = useSelector(Selectors.initAdminUserIsLoading);
	const isAuthenticated = useSelector(Selectors.isAuthenticated);

	useEffect(() => {
		dispatch(initAdminUserData({}));
	}, [dispatch]);

	const publicRoutes = useRoutes([
		{
			path: '/',
			element: <PublicLayout />,
			children: [
				...renderRoutes(GLOBAL_ROUTES.PUBLIC),
				{ index: true, element: <Navigate to='/login' /> },
			],
		},
		{ path: '*', element: <Navigate to='/login' /> },
	]);
	const privateRoutes = useRoutes([
		{
			path: '/',
			element: <PrivateLayout />,
			children: [
				...renderRoutes(GLOBAL_ROUTES.PRIVATE),
				{ index: true, element: <Navigate to='/dashboard' /> },
			],
		},
		{ path: '/access-denied', element: <AccessDenied /> },
		{ path: '*', element: <Navigate to='/dashboard' /> },
	]);

	if (isLoading) {
		return (
			<Stack height={'100vh'} width={'100vh'} alignItems='center'>
				<Loader />
			</Stack>
		);
	}

	if (isAuthenticated) return privateRoutes;
	return publicRoutes;
};

export default AppRoutes;
